import React from 'react';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import Perfil from './pages/Perfil';
import Stats from './pages/Stats';
import { Route, Switch, Redirect } from 'react-router-dom';
import { isAuthenticated } from './services/auth';
import NotFound from "./pages/NotFound";
import Offers from "./pages/Offers";
import {UserProvider} from "./context/UserContext";

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={(props) =>
			isAuthenticated() ? (
				<Component {...props} />
			) : (
				<Redirect to={{ pathname: '/', state: { from: props.location } }} />
			)
		}
	/>
);

const App = () => (
	<Switch>
		<Route exact path="/" component={Login} />
		<Route exact path="/reset-password" component={ResetPassword} />
		<UserProvider>
			<PrivateRoute exact path="/home" component={Home} />
			<PrivateRoute exact path="/perfil" component={Perfil} />
			<PrivateRoute exact path="/stats" component={Stats} />
			<PrivateRoute exact path="/offers" component={Offers} />
		</UserProvider>
		<Route component={NotFound} />
	</Switch>
);

export default App;